export default __webpack_public_path__ + "static/media/Bari.fd7fd590.png";